import { Link } from 'react-router-dom';
import { dossiers } from '@/mocks/dossiers';
import { homeAnchors, stats } from '@/mocks/site';
import DimensionTag from '@/components/feature/DimensionTag';

const heroImage =
  'https://readdy.ai/api/search-image?query=abstract%20editorial%20investigation%20board%20with%20overlapping%20paper%20clippings%20connected%20by%20thin%20amber%20threads%2C%20warm%20cream%20and%20deep%20rust%20palette%2C%20soft%20directional%20window%20light%2C%20cinematic%20quiet%20still%20life%2C%20high%20detail&width=1100&height=1300&seq=bao-hero-01&orientation=portrait';

export default function HomeHero() {
  const featured = dossiers[0];

  return (
    <section className="paper-grain relative w-full overflow-hidden border-b border-background-200">
      <div className="mx-auto grid w-full max-w-[1440px] grid-cols-1 items-stretch gap-0 lg:grid-cols-12">
        <div className="animate-rise flex flex-col justify-center px-4 py-14 md:px-8 md:py-20 lg:col-span-7 lg:py-24">
          <div className="flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-3 py-1 font-label text-xs text-primary-700">
              <span className="animate-pulse-dot h-1.5 w-1.5 rounded-full bg-primary-500" />
              深度拆解 · 每 48 小时更新
            </span>
            <span className="font-label text-xs tracking-[0.24em] text-foreground-500">CASE FILE · 2026</span>
          </div>

          <h2 className="mt-7 max-w-2xl font-heading text-3xl font-bold leading-[1.18] text-foreground-950 md:text-5xl lg:text-[3.4rem]">
            把一条爆料，
            <br />
            拆成可以<span className="text-primary-600">顺着看</span>的脉络
          </h2>

          <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-foreground-700 md:text-lg">
            不只告诉你发生了什么。爆料背后细节、被忽略的伏笔、时间线关键节点、事件隐藏关联，四个维度一起摊开，
            让零散线索自己连成线。
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/dossiers"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-open-line text-base" />
              进入拆解档案库
            </Link>
            <a
              href="#timeline"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-foreground-800"
            >
              <i className="ri-time-line text-base" />
              先看时间线长廊
            </a>
          </div>

          <nav aria-label="页面锚点导航" className="mt-10 flex flex-wrap items-center gap-x-5 gap-y-2">
            {homeAnchors.map((anchor) => (
              <a
                key={anchor.href}
                href={anchor.href}
                className="inline-flex items-center gap-1.5 whitespace-nowrap font-label text-xs text-foreground-600 transition-colors hover:text-primary-600"
              >
                <i className="ri-arrow-down-s-line text-foreground-400" />
                {anchor.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="relative lg:col-span-5">
          <div className="relative h-72 w-full sm:h-96 lg:h-full lg:min-h-[620px]">
            <img
              src={heroImage}
              alt="爆料看点拆解工作台示意图，纸片线索与连线构成事件脉络"
              title="爆料看点 深度拆解工作台 - 爆料背后细节与事件隐藏关联"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-foreground-950/10 to-transparent" />

            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
              <span className="font-label text-[11px] tracking-[0.3em] text-accent-200">本期焦点 / FEATURED</span>
              <div className="mt-3">
                <DimensionTag id={featured.dimension} />
              </div>
              <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-background-50 md:text-xl">
                <Link to={`/dossier/${featured.id}`} className="hover:text-accent-200">
                  {featured.title}
                </Link>
              </h3>
              <Link
                to={`/dossier/${featured.id}`}
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap font-label text-xs text-background-100 hover:text-accent-200"
              >
                阅读完整拆解
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-100">
        <div className="mx-auto grid w-full max-w-[1440px] grid-cols-2 gap-px px-4 py-8 md:grid-cols-4 md:px-8">
          {stats.map((stat) => (
            <div key={stat.label} className="px-1 md:px-4">
              <p className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{stat.value}</p>
              <p className="mt-1 font-label text-sm text-foreground-800">{stat.label}</p>
              <p className="mt-1 font-label text-xs text-foreground-500">{stat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}